export const getRtlField = (name, label) => ({
	label,
	name,
	"widget": "rtlmarkdown"
});

export const getTemplateKeyField = (template) => ({
	"label": "Template Key",
	"name": "templateKey",
	"widget": "hidden",
	"default": template
});

export const getDateField = (label, name = "date", overrides = {}) => ({
	label,
	name,
	widget: "datetime",
	...overrides,
});

export const getImageField = (overrides = {}) => ({
	"label": "Image",
	"name": "image",
	"widget": "image",
	...overrides,
});

export const IMAGE_Y_POSITION_OPTIONS = [
	{
		"label": "Top",
		"value": "top"
	},
	{
		"label": "Bottom",
		"value": "bottom"
	},
	{
		"label": "Center",
		"value": "center"
	},
	{
		"label": "Y: 0",
		"value": "0%"
	},
	{
		"label": "Y: 10%",
		"value": "10%"
	},
	{
		"label": "Y: 20%",
		"value": "20%"
	},
	{
		"label": "Y: 30%",
		"value": "30%"
	},
	{
		"label": "Y: 35%",
		"value": "35%"
	},
	{
		"label": "Y: 40%",
		"value": "40%"
	},
	{
		"label": "Y: 50%",
		"value": "50%"
	},
	{
		"label": "Y: 55%",
		"value": "55%"
	},
	{
		"label": "Y: 60%",
		"value": "60%"
	},
	{
		"label": "Y: 70%",
		"value": "70%"
	},
	{
		"label": "Y: 75%",
		"value": "75%"
	},
	{
		"label": "Y: 80%",
		"value": "80%"
	},
	{
		"label": "Y: 90%",
		"value": "90%"
	}
];

export const TITLE_FIELD = {
	"label": "Title",
	"name": "title",
	"widget": "string"
};

export const AUTHOR_FIELD = {
	"label": "Author",
	"name": "author",
	"widget": "string",
	"default": "מונטסורי בייבי"
};

export const PUBLISH_DATE_FIELD = getDateField("Publish Date");

export const LIVE_DATE_FIELD = getDateField("Live Date", "liveDate", {"required": false,});

export const DESCRIPTION_FIELD = {
	"label": "Description",
	"name": "description",
	"widget": "text",
	"required": true,
	"hint": "חייב להיות לפחות 70 תווים",
};

export const FEATURED_FIELD = {
	"label": "Featured Post",
	"name": "featuredpost",
	"widget": "boolean",
	"default": false,
};

export const IMAGE_FIELD = getImageField();

export const IMAGE_ALT_FIELD = {
	"label": "Image ALT Text",
	"name": "imageAlt",
	"widget": "text",
	"required": true,
	"hint": "טקסט שמתאר את התמונה",
};

export const BODY_FIELD = getRtlField("body", "Body");

export const BODY_FIELD_OPTIONAL = {
	...BODY_FIELD,
	required: false,
};

export const TAGS_FIELD = {
	"label": "Tags",
	"name": "tags",
	"widget": "list"
};

export const IMAGE_Y_POSITION_FIELD = {
	"label": "Image vertical position",
	"name": "imageYPosition",
	"widget": "select",
	"default": "center",
	"options": IMAGE_Y_POSITION_OPTIONS,
};

export const POST_ID_FIELD = {
	"label": "PostId",
	"name": "postId",
	"widget": "postId"
};

export const POST_TO_FB_FIELD = {
	"label": "Publish to Facebook",
	"name": "fbPublish",
	"widget": "boolean",
	"default": true
};

export const POST_TO_TWITTER_FIELD = {
	"label": "Publish to Twitter",
	"name": "twitterPublish",
	"widget": "boolean",
	"default": true
};

export const SOCIAL_TEXT_FIELD = {
	"label": "Social Publish Text",
	"name": "socialText",
	"widget": "text",
	"required": false
};

export const LOCATION_FIELD = {
	"label": "Location",
	"name": "location",
	"widget": "map",
	"required": false
};

export const HEADING_FIELD = {
	"label": "Heading",
	"name": "heading",
	"widget": "string"
};

export const SUBHEADING_FIELD = {
	"label": "Subheading",
	"name": "subheading",
	"widget": "string"
};

export const SECTIONS_FIELD = {
	"label": "Sections",
	"name": "sections",
	"widget": "list"
};

export const SHOW_DATE_FIELD = {
	"label": "Show Date",
	"name": "showDate",
	"widget": "boolean",
	"required": false,
	"default": false,
};

export const ALL_SALE_INDEX_FIELD = {
	"label": "All Sale Page Index",
	"name": "allSaleIndex",
	"widget": "boolean",
	"required": false,
	"default": false,
};

export const SHOW_NEW_FIELD = {
	label: "Show New Badge",
	name: "showNew",
	widget: "boolean",
	required: false,
	default: false,
};

export const SHOW_DISCLAIMER_FIELD = {
	label: "Show Product Disclaimer",
	name: "showDisclaimer",
	widget: "boolean",
	required: true,
	default: false
};
